import phosphorIcons from './phosphorIcons';
import lucideIcons from './lucideIcons';
import icons, { type IconName, type IconPathProps } from './iconPath'

type IconProps = IconPathProps & {
  icon: IconName
}

export function Icon({ icon, color, width, height, className }: IconProps) {
  const IconPath = icons[icon]

  if (!IconPath) return null

  if (process.env.REACT_APP_ICON_SET === 'phosphor-fill') {
    const { component, size, color: defaultColor } = phosphorIcons[icon];
    return <>{component({
      'aria-hidden': true,
      style: { width: width ?? size, height: height ?? size },
      color: color ?? defaultColor,
      className,
    })}</>;
  }

  if (process.env.REACT_APP_ICON_SET === 'lucide') {
    const { component: LucideIcon, size, color: defaultColor } = lucideIcons[icon];
    return (
      <LucideIcon
        aria-hidden="true"
        width={width ?? size}
        height={height ?? size}
        color={color ?? defaultColor}
        className={className}
      />
    );
  }

  return (
    <IconPath
      color={color}
      width={width}
      height={height}
      className={className}
    />
  )
}

export type { IconName }
